import React from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AuroraBackdrop } from './components/AuroraBackdrop';
import { BrandMark } from './components/BrandMark';
import { DashboardShell } from './components/layout/DashboardShell';
import { Toaster } from './components/ui/Sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { Dashboard } from './pages/Dashboard';
import { Landing } from './pages/Landing';
import { Security } from './pages/Security';
import { Settings } from './pages/Settings';
import { Students } from './pages/Students';
function Splash({
  message
}: {
  message: string;
}) {
  return <div className="relative grid min-h-screen w-full place-items-center px-6" data-id="element-0" data-mp="28ufmg62gz4gf">
      <AuroraBackdrop intensity="marketing" data-id="element-1" data-mp="28s2xva27hvue" />
      <div className="glass flex flex-col items-center gap-5 rounded-3xl px-10 py-9 text-center" data-id="element-2" data-mp="23w4ek0vqj40u">
        <BrandMark size="lg" withText={false} className="animate-float" data-id="element-3" data-mp="3ikqytzf4l45q" />
        <div data-id="element-4" data-mp="3mlavl1vse5rc">
          <p className="text-sm font-semibold tracking-tight text-foreground" data-id="element-5" data-mp="3ml17xky7saot">Student Recorder</p>
          <p className="mt-1 text-xs text-muted-foreground" data-id="element-6" data-mp="3rbrc4uuwm7hx">{message}</p>
        </div>
        <Loader2 className="h-4 w-4 animate-spin text-brand" data-id="element-7" data-mp="5or2zhbcs60" />
      </div>
    </div>;
}

/** Requires a live Supabase session plus a satisfied master-password gate. */
function ProtectedRoute() {
  const {
    user,
    initializing,
    unlocked
  } = useAuth();
  if (initializing) return <Splash message="Restoring your secure session…" data-id="element-8" data-mp="33oi3h8ycvayl" />;
  if (!user) return <Navigate to="/" replace data-id="element-9" data-mp="38k6v8q44vnkc" />;
  if (!unlocked) return <Navigate to="/security" replace data-id="element-10" data-mp="3dkl6eh117dml" />;
  return <Outlet data-id="element-11" data-mp="3dmfqjt4hb1pm" />;
}

/** The master-password step, only reachable once Google sign-in succeeded. */
function SecurityRoute() {
  const {
    user,
    initializing,
    unlocked
  } = useAuth();
  if (initializing) return <Splash message="Completing Google sign-in…" data-id="element-12" data-mp="st2i6gybyti7" />;
  if (!user) return <Navigate to="/" replace data-id="element-13" data-mp="35oxgs1yt6tn" />;
  if (unlocked) return <Navigate to="/dashboard" replace data-id="element-14" data-mp="38kvshhq5xim" />;
  return <Security data-id="element-15" data-mp="3udkmfuysas9v" />;
}
function AppToaster() {
  const {
    theme
  } = useTheme();
  return <Toaster theme={theme} position="top-right" richColors closeButton data-id="element-16" data-mp="d4e57s05daw6" />;
}
export function App() {
  return <ThemeProvider data-id="element-17" data-mp="851hl51gbzsj">
      <AuthProvider data-id="element-18" data-mp="86w6eufugc1w">
        <BrowserRouter data-id="element-19" data-mp="86cm572q1bkp">
          <Routes data-id="element-20" data-mp="3gle7udba4tcj">
            <Route path="/" element={<Landing data-id="element-22" data-mp="3gmfvdh9hf8b5" />} data-id="element-21" data-mp="3gkv0trn63pda" />
            <Route path="/security" element={<SecurityRoute data-id="element-24" data-mp="3bmbgfvo82ln1" />} data-id="element-23" data-mp="3glnxu0wbr0i8" />
            <Route element={<ProtectedRoute data-id="element-26" data-mp="3bnmedeuzkz68" />} data-id="element-25" data-mp="3bncpxvplb02n">
              <Route element={<DashboardShell data-id="element-28" data-mp="3qb7m5m2t3mkh" />} data-id="element-27" data-mp="3bkgqg2y3g3c3">
                <Route path="/dashboard" element={<Dashboard data-id="element-30" data-mp="3qcipxlw94ubl" />} data-id="element-29" data-mp="3qc95edtz7fda" />
                <Route path="/students" element={<Students data-id="element-32" data-mp="3ljg09ouli50o" />} data-id="element-31" data-mp="3lkr6dvbijouy" />
                <Route path="/settings" element={<Settings data-id="element-34" data-mp="2xun1zlqi3l2w" />} data-id="element-33" data-mp="3lj67jti61jra" />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace data-id="element-36" data-mp="2sw21dl7c6zdx" />} data-id="element-35" data-mp="2xssebznuhev4" />
          </Routes>
        </BrowserRouter>
        <AppToaster data-id="element-37" data-mp="2stzbr2a3j89q" />
      </AuthProvider>
    </ThemeProvider>;
}